import { useEffect, useState } from "react";
import { platform } from "@/platform";

/** Live connectivity. Native shells use the device network status. */
export function useOnlineStatus(): boolean {
  const [online, setOnline] = useState(() => platform.network.isOnline());

  useEffect(() => platform.network.subscribe(setOnline), []);

  return online;
}
